<template>
  <div>
    <v-layout pt-3 wrap px-2>
      <v-flex xs12 text-left>
        <span style="font-family:opensansextrabold;font-size:18px;">
          <v-icon style="font-size:14px;color:#000">mdi-circle-outline</v-icon>&nbsp;Inventory
        </span>
      </v-flex>
    </v-layout>
    <v-layout wrap px-2>
      <v-flex xs8 md8 lg8 text-left>
        <v-layout wrap justify-start>
          <v-flex xs2 lg1 text-left align-self-center>
            <span
              class="pr-12"
              style="color:#8D8D8D;font-family:opensanslight;font-size:14px"
            >Status</span>
          </v-flex>
          <v-flex xs10 lg4 xl2 text-left align-self-center>
            <v-radio-group v-model="listStatus" row>
              <v-layout wrap>
                <v-flex xs6 text-left align-self-center>
                  <v-radio
                    value="active"
                    class="mx-2"
                    label="Active"
                    :ripple="false"
                    color="#63028F"
                  ></v-radio>
                </v-flex>
                <v-flex xs6 text-left align-self-center>
                  <v-radio
                    value="inactive"
                    class="mx-2"
                    label="Inactive"
                    :ripple="false"
                    color="#63028F"
                  ></v-radio>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md4 lg4 x4>
        <v-toolbar height="40vh">
          <v-toolbar-title
            style="color:#8B8B8B;font-family:opensansregular;font-size:16px;"
          >Searching essentials</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="hidden-xs-only">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center py-2 v-if="myProducts.length>0">
      <v-flex xs12 v-for="(item,i) in myProducts" :key="i" py-2>
        <v-card>
          <v-layout wrap pa-2>
            <v-flex xs12 sm12 md1 justify-left px-2>
              <v-img :src="baseURL+'/u/'+item.photos[0]" aspect-ratio="1" contain height="100px"></v-img>
            </v-flex>
            <v-flex xs12 md5 lg5 style="text-align:left;">
              <v-layout wrap pt-3>
                <v-flex xs12>
                  <span style="font-family:opensansbold ;font-size:16px;">{{item.productname}}</span>
                </v-flex>
                <v-flex xs6 md2 lg2>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Weight</span>
                  <br />
                  <span style="font-family:opensansbold ;font-size:20px;">{{500}}</span>
                </v-flex>
                <v-flex xs6 md2 lg2>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Stock</span>
                  <br />
                  <span style="font-family:opensansbold ;font-size:20px;">{{item.stockquantity}}</span>
                </v-flex>
                <v-flex xs6 md2 lg2>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Price</span>
                  <br />
                  <span style="font-family:opensansbold ;font-size:20px;">{{item.orginalprice}}</span>
                </v-flex>
                <v-flex xs6 md3 lg3>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Offer Price</span>
                  <br />
                  <span
                    style="font-family:opensansbold ;color:#3BC17A;font-size:20px;"
                  >{{item.price}}</span>
                </v-flex>
                <v-flex xs6 md3 lg3>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Offer</span>
                  <br />
                  <span
                    style="font-family:opensansbold ;color:#3BC17A;font-size:20px;"
                  >{{item.discountpercentage}} %</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs12 md2 lg2 style="text-align:center">
              <v-layout wrap justify-center>
                <v-flex xs12>
                  <span style="color:#8D8D8D;font-family:opensanslight;font-size:14px">Item added on</span>
                </v-flex>
                <v-flex xs12>
                  <span
                    style="font-family:opensanssemibold;font-size:16px;color:#000000"
                  >{{formatDate(item.account_create_at)}}</span>
                </v-flex>
                <v-flex xs12 align-self-center>
                  <v-btn
                    v-if="item.instock"
                    dark
                    depressed
                    :ripple="false"
                    color="#FFBC6E"
                    style="text-transform:none"
                  >
                    <span style="font-family:poppinsregular;font-size:14px">Available</span>
                  </v-btn>
                  <v-btn
                    v-if="!item.instock"
                    dark
                    depressed
                    :ripple="false"
                    color="#EB6359"
                    style="text-transform:none"
                  >
                    <span style="font-family:poppinsregular;font-size:14px">Out of Stock</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md3 align-self-center>
              <v-layout justify-center wrap>
                <v-flex px-2 xs12 align-self-center>
                  <span
                    style="color:#000000;font-family:opensanssemibold;font-size:16px"
                  >Status - {{item.status}}</span>
                </v-flex>
                <v-flex px-2 xs4 xl3 v-if="item.status!='Pending'" text-right align-self-center>
                  <v-switch
                    v-model="item.status"
                    true-value="Active"
                    false-value="Inactive"
                    color="#63028F"
                    :ripple="false"
                    @click="changeProductStatus(item)"
                  >
                    <template slot="label">
                      <span
                        style="color:#000000;font-family:opensanssemibold;font-size:16px"
                      >{{item.status}}</span>
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap pt-5>
                <v-flex xs6 lg4 pa-1>
                  <v-btn
                    tile
                    block
                    outlined
                    color="warning"
                    @click="editProduct(item)"
                    style="text-transform:none"
                  >
                    <v-icon style="color:#000" left>mdi-pencil</v-icon>
                    <span style="color:#000;font-family:poppinsregular;font-size:14px">Edit</span>
                  </v-btn>
                </v-flex>
                <v-flex xs6 lg4 pa-1>
                  <v-btn
                    tile
                    block
                    outlined
                    color="red"
                    @click="deleteProductDial(item)"
                    style="text-transform:none"
                  >
                    <v-icon style="color:#000000" left>mdi-delete</v-icon>
                    <span style="color:#000;font-family:poppinsregular;font-size:14px">Delete</span>
                  </v-btn>
                </v-flex>
                <!-- <v-flex xs6 lg4 pa-1>
                  <v-btn
                    tile
                    block
                    outlined
                    color="red"
                    @click="deleteProductDial(item)"
                    style="text-transform:none"
                  >
                    <v-icon style="color:#000000" left>mdi-eye</v-icon>
                    <span style="color:#000;font-family:poppinsregular;font-size:14px">Status</span>
                  </v-btn>
                </v-flex>-->
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex>
        <span
          style="font-family:opensanssemibold;font-size:16px;color:#000000"
        >Try Adding New Products</span>
      </v-flex>
    </v-layout>

    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="color:#000000;font-family:opensanssemibold;font-size:18px"
            >Do you want to delete this product ?</span>
          </v-flex>
          <v-flex xs12>
            <span
              style="color:#000000;font-family:opensanssemibold;font-size:14px"
            >{{curProduct.productname}}</span>
          </v-flex>
          <v-flex xs6>
            <v-btn class="ma-2" tile outlined color="red" @click="deleteProduct">
              <span style="color:red">Yes</span>
            </v-btn>
          </v-flex>
          <v-flex xs6>
            <v-btn class="ma-2" tile outlined color="green" @click="deleteDialogue=false">
              <span style="color:green">No</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["myProducts"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      curProduct: {},
      deleteDialogue: false,
      listStatus: "Active",
    };
  },
  watch: {
    listStatus() {
      this.$emit("stepper", {
        getList: true,
        listStatus: this.listStatus,
      });
    },
  },
  methods: {
    editProduct(item) {
      this.$emit("stepper", {
        editProduct: true,
        product: item,
      });
    },
    deleteProductDial(item) {
      this.curProduct = item;
      this.deleteDialogue = true;
    },
    changeProductStatus(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/status",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item._id,
          status: item.status,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$emit("stepper", {
              getList: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteProduct() {
      if (this.curProduct._id) {
        this.appLoading = true;
        axios({
          method: "GET",
          url: "/product/delete",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: {
            id: this.curProduct._id,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.deleteDialogue = false;
              this.curProduct = {};
              this.$emit("stepper", {
                getList: true,
              });
            }
          })
          .catch((err) => {
            this.ServerError = true;
            console.log(err);
          });
      }
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>